import React, { useState } from "react";
import { useTheme } from "./AHTheme/AHTheme";
import {
  View,
  Image,
  ActivityIndicator,
  ViewStyle,
  StyleProp,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { useAHImage } from "./useAHImage";

type AHImageViewProps = {
  imageURI: string;
  style?: StyleProp<ViewStyle>;
};

export const AHImageView = ({ imageURI, style }: AHImageViewProps) => {
  const theme = useTheme();
  const { imageProps, isLoading, error } = useAHImage({});
  const [layout, setLayout] = useState({ height: 0, width: 0 });
  return (
    <View
      style={[
        {
          flex: 1,
        },
        style,
      ]}
      onLayout={(layout) => {
        setLayout({ ...layout.nativeEvent.layout });
      }}
    >
      <Image
        {...imageProps}
        source={{ uri: imageURI, cache: "force-cache" }}
        style={{ width: layout.width, height: layout.height, flex: 1 }}
        resizeMethod="scale"
        resizeMode="contain"
      />
      {isLoading || error ? (
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {error ? <ImageError /> : <ActivityIndicator color={theme.surface} />}
        </View>
      ) : null}
    </View>
  );
};

const ImageError = () => {
  return (
    <View
      style={{
        height: 80,
        width: 80,
        backgroundColor: "rgba(0,0,0,0.3)",
        alignItems: "center",
        justifyContent: "center",
        margin: 5,
        borderRadius: 5,
      }}
    >
      <Feather
        color="#FFF"
        size={20}
        style={{ alignSelf: "center" }}
        name="image"
      />
    </View>
  );
};
